import { render, staticRenderFns } from "./cwAccount.vue?vue&type=template&id=34b937c1&scoped=true"
import script from "./cwAccount.vue?vue&type=script&lang=js"
export * from "./cwAccount.vue?vue&type=script&lang=js"
import style0 from "./cwAccount.vue?vue&type=style&index=0&id=34b937c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b937c1",
  null
  
)

export default component.exports